// src/encounter/device-trends/device-trends-catalog.ts
// The adapter from the PA's wearable trends to Antonin's catalog DeviceTrendsCard (@scripsteam/signal, D-79): data only.
// The card, its look and its chart are his; this file maps fields and draws nothing. The values, dates and labels are the
// ones the PA card shows (clinic-day dating, newest last sync per provider), so the clinical sign-off (1 Nov) still holds.
import type { DeviceTrendSeries } from '@scripsteam/signal';
import type { WearableSeries } from '../lib/wearable-trends';
import { railDate } from '../lib/rail-date';
import { formatSync } from './device-trends-format';

/** His card reads 30 daily values ending on `end` (ISO day). The PA window is the same 30 clinic days, oldest first.
 *  `datesOnly`: the sync line without its time, as the PA card draws it in the left rail with `railFixes`. */
export function toCatalogSeries(series: WearableSeries[], { datesOnly = false }: { datesOnly?: boolean } = {}): DeviceTrendSeries[] {
  return series.map((s) => ({
    key: s.key,
    label: s.label,
    unit: s.unit,
    loinc: s.loinc,
    device: s.device,
    connected: s.connected,
    points: s.points.map((p) => p.value),
    end: s.points[s.points.length - 1]?.date ?? s.latest.date,
    lastSyncAt: s.lastSyncAt ? (datesOnly ? railDate(s.lastSyncAt) : formatSync(s.lastSyncAt)) : null,
  }));
}
